import { useEffect, useRef, useState } from 'react';

export const useImageRetryOnReconnect = () => {
  const imgElementRef = useRef<HTMLImageElement | null>(null);
  const [retryCacheBuster, setRetryCacheBuster] = useState<number | null>(null);

  useEffect(() => {
    const checkAndRetry = () => {
      const img = imgElementRef.current;
      if (img && img.complete && img.naturalWidth === 0) {
        setRetryCacheBuster(Date.now());
      }
    };

    checkAndRetry();

    window.addEventListener('online', checkAndRetry);
    return () => window.removeEventListener('online', checkAndRetry);
  }, []);

  return { imgElementRef, retryCacheBuster };
};
